/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react"
import Patient from "../../../../../libs/api/services/Patient"
import Questionnaire from "../../../../../libs/api/services/Questionnaire"
import QuestionnaireBuilderContext from "../QuestionnaireBuilderProvider"
import { AdminEditText, AdminLayoutWrapper, CommonLayoutWrapper } from "./QBuilderComponentMultiSelect"
import QBuilderFieldLink from "./QBuilderFieldLink"

export default function QBuilderComponentTextBox({
    Component,
    activeQuestionnaireAssignment,
    accessTypes,
    onAction,
    idx,
    edit,
    view,
    defaultMode,
    SectionComponents,
    values, }) {
    const { SetComponentValue, ComponentValues, SetResponse, ComponentAnswers, GetComponentValues } = useContext(QuestionnaireBuilderContext)
    const [mode, setMode] = useState(edit ? '' : '')
    const [ComponentResponse, setComponentResponse] = useState(ComponentAnswers[Component.id] || "");
    const isEditingRef = useRef(false)
    const lastSavedValueRef = useRef(ComponentAnswers[Component.id] || "")
    const [Link, setLink] = useState({
        autoFill: false,
        updateRecords: false
    })

    // Debounce SetResponse when ComponentResponse changes
    // Debounce SetResponse when ComponentResponse changes. Use saveResponse wrapper
    // so we can track the last saved value and avoid races with external updates.
    const saveResponse = (value) => {
        SetResponse(Component, value, true)
        lastSavedValueRef.current = value
    }

    useEffect(() => {
        if (!accessTypes || !accessTypes.includes('Edit')) return;
        // If nothing changed compared to last saved, skip scheduling save.
        if (ComponentResponse === lastSavedValueRef.current) return
        const handler = setTimeout(() => {
            // Only save the latest local value when debounce fires.
            saveResponse(ComponentResponse)
        }, 3000); // 3s debounce
        return () => clearTimeout(handler);
    }, [ComponentResponse]);

    // Sync local state with context if ComponentAnswers changes externally
    // Sync local state with context only when not actively editing. While the user
    // is editing, avoid clobbering their input. Keep lastSavedValueRef in-sync.
    useEffect(() => {
        const answer = ComponentAnswers[Component.id] || ""
        if (isEditingRef.current && answer !== lastSavedValueRef.current) {
            // There's an external change but user is editing — do not overwrite.
            return
        }
        setComponentResponse(answer)
        lastSavedValueRef.current = answer
    }, [ComponentAnswers, Component.id]);

    useEffect(() => {
        const _checkLinkedFields = (answer) => {
            if (!answer || answer === "")
                Questionnaire
                    .GetLinkPatientProfile(Component.id)
                    .then((r) => {
                        setLink(r)
                        if (r.autoFill && view !== "New") {
                            Patient
                                .GetPatientProfileDetail(activeQuestionnaireAssignment.assignedTo.id, r.linkedValue.id)
                                .then((d) => {
                                    setComponentResponse(d.detail)
                                }).catch((e) => { })
                        }
                    }).catch((e) => { })
        }
        _checkLinkedFields(ComponentAnswers[Component.id])
    }, [Component.id, ComponentAnswers, activeQuestionnaireAssignment.assignedTo.id, view])
    // if (!accessTypes) return <></>
    return <CommonLayoutWrapper
        OnEdit={() => setMode('Edit Text')}
        edit={edit}
        mode={mode}
        accessTypes={accessTypes}
        AdminMode={<AdminLayoutWrapper
            Component={Component}
            mode={mode}
            setMode={setMode}
            Tabs={{
                "Edit Text": {
                    mode: "Set Text",
                    component: <AdminEditText Component={Component} />
                },
                "Link": {
                    mode: "Link Field",
                    component: <QBuilderFieldLink ComponentId={Component.id} />
                },
            }}
        />}
        NormalMode={
            <>
                {GetComponentValues(Component.id)["Question"]}
                {
                    accessTypes.includes('Edit')
                        ? (
                            <textarea
                                rows={10}
                                value={ComponentResponse}
                                onChange={e => setComponentResponse(e.target.value)}
                                onFocus={() => { isEditingRef.current = true }}
                                onBlur={() => { isEditingRef.current = false; saveResponse(ComponentResponse) }}
                                className={`form-control form-control-sm ${view === 'Form' ? 'form-view' : ''}`}
                                style={view === 'Form' ?
                                    {
                                        backgroundColor: 'transparent'
                                    } : {}}
                                placeholder={GetComponentValues(Component.id)["Question"]}
                            />
                        ) : (
                            <div>{ComponentResponse}</div>
                        )
                }

            </>
        }
    />
}
